/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationStatus } from './HomeHealthCertificationStatus';
import {
    HomeHealthCertificationStatusFromJSON,
    HomeHealthCertificationStatusFromJSONTyped,
    HomeHealthCertificationStatusToJSON,
    HomeHealthCertificationStatusToJSONTyped,
} from './HomeHealthCertificationStatus';
import type { HomeHealthCertificationReference } from './HomeHealthCertificationReference';
import {
    HomeHealthCertificationReferenceFromJSON,
    HomeHealthCertificationReferenceFromJSONTyped,
    HomeHealthCertificationReferenceToJSON,
    HomeHealthCertificationReferenceToJSONTyped,
} from './HomeHealthCertificationReference';

/**
 * 
 * @export
 * @interface HomeHealthCertificationAttestation
 */
export interface HomeHealthCertificationAttestation {
    /**
     * 
     */
    status: HomeHealthCertificationStatus;
    /**
     * 
     */
    ref: Array<HomeHealthCertificationReference>;
}



/**
 * Check if a given object implements the HomeHealthCertificationAttestation interface.
 */
export function instanceOfHomeHealthCertificationAttestation(value: object): value is HomeHealthCertificationAttestation {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('ref' in value) || value['ref'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationAttestationFromJSON(json: any): HomeHealthCertificationAttestation {
    return HomeHealthCertificationAttestationFromJSONTyped(json, false);
}

export function HomeHealthCertificationAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationAttestation {
    if (json == null) {
        return json;
    }
    return {
        
        'status': HomeHealthCertificationStatusFromJSON(json['status']),
        'ref': ((json['ref'] as Array<any>).map(HomeHealthCertificationReferenceFromJSON)),
    };
}

export function HomeHealthCertificationAttestationToJSON(json: any): HomeHealthCertificationAttestation {
    return HomeHealthCertificationAttestationToJSONTyped(json, false);
}

export function HomeHealthCertificationAttestationToJSONTyped(value?: HomeHealthCertificationAttestation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': HomeHealthCertificationStatusToJSON(value['status']),
        'ref': ((value['ref'] as Array<any>).map(HomeHealthCertificationReferenceToJSON)),
    };
}

